<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Winst uit onderneming als medegerechtigde of schuldeiser
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Is de belastingplichtige niet hoofdelijk aansprakelijk voor de schulden van de onderneming? En kan hij
                voor de onderneming ook geen bindende afspraken maken? Dan is de belastingplichtige meestal
                mede-gerechtelijk in een onderneming. Dat is bijvoorbeeld het geval als hij commanditair vennoot was in
                een commanditaire vennootschap. Hij loopt dan alleen risico dat hij het bedrag van het commanditaire
                kapitaal kwijtraakt.

                <div class="space20"></div>

                Leende de belastingplichtige geld aan een ondernemer en functioneerde deze lening in feite als eigen
                vermogen van de onderneming? Of was de vergoeding voor de lening sterk afhankelijk van de winst van de
                onderneming? Dan is er sprake van winst uit onderneming.

                <div class="space20"></div>

                Als medegerechtigde of geldverstrekker krijgt belastingplichtige geen ondernemersaftrek en
                mkb-winstvrijstelling.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Winst uit hoofde van een schuldvordering
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Leende de ondernemer in {{ this.year }} geld aan een ondernemer en functioneerde deze lening in feite
                als eigen vermogen van de onderneming? Of was de vergoeding voor de lening sterk afhankelijk van de
                winst van de onderneming? Dan geef je de opbrengst aan als winst uit onderneming.
                <div class="space20"></div>
                De geldverstrekker heeft wel winst uit onderneming, maar krijgt geen ondernemersaftrek en
                mkb-winstvrijstelling.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Agrarische activiteiten
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een onderneming met agrarische activiteiten is een bedrijf dat is gericht op het maken van producten van
                akkerbouw, weidebouw of tuinbouw. Daarbij horen ook fruitteelt en het kweken van bomen, bloemen,
                bloembollen en paddenstoelen.

                <div class="space20"></div>

                In het kader van veehouderij horen daar het fokken, mesten of houden van dieren bij, als dat gericht is
                op het verbruik door de consument. Ook binnenvisserij en visteelt gelden als een agrarisch bedrijf. Dit
                geldt niet voor een dierentuin of hertenkamp.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Wijzigen van een waarderingsstelsel
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij wijzigingen in het waarderingsstelsel van activa gaat het om wijzigingen in balansposten.
                Bijvoorbeeld een wijziging in het systeem van:<br>

                <li class="list">voorraadwaardering<br/>
                    Bijvoorbeeld vervanging van een waarderingssysteem op kostprijs of lagere marktwaarde door een
                    ijzerenvoorraadstelsel. Hieronder valt ook een wijziging van de grondslagen van de
                    voorraadwaardering (bijvoorbeeld als de ondernemer het ijzerenvoorraadstelsel gebruikt en de vaste
                    basisprijs hebt verlaagd of verhoogd).
                </li>

                <li class="list">afschrijving<br/>
                    Bijvoorbeeld vervanging van een systeem van lineaire afschrijving door een systeem van afschrijving
                    naar boekwaarde. Ook hierbij is het mogelijk dat je de grondslagen van de afschrijving hebt
                    gewijzigd. Bijvoorbeeld door de hoogte van de restwaarde of de hoogte van het
                    afschrijvingspercentage aan te passen.
                </li>

                <div class="space20"></div>

                <b>Let op!</b><br/>
                Een wijziging in het waarderingsstelsel is alleen toegestaan als goed koopmansgebruik* dit
                rechtvaardigt. Ook het nieuwe waarderingsstelsel moet in overeenstemming zijn met goed koopmansgebruik.
                De
                stelselwijziging mag niet willekeurig zijn of alleen gericht zijn op het behalen van incidenteel fiscaal
                voordeel.

                <div class="space20"></div>

                <b>*Goed koopmansgebruik</b><br/>
                Een ondernemer moet handelen zoals een goed koopman zou handelen bij bepaling van de fiscale jaarwinst:
                de baten en lasten worden zo goed mogelijk toegerekend aan de jaren waarop zij betrekking hebben. Elke
                gedragslijn is hierin toegestaan, zolang die bedrijfseconomisch aanvaardbaar is en niet in strijd is met
                de tekst, opzet of strekking van de Nederlandse belastingwet.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Willekeurige afschrijving
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Willekeurig afschrijven betekent dat de ondernemer naast de gewone afschrijving zelf bepaalt hoe en
                wanneer hij een bedrijfsmiddel afschrijft. <br/>
                Je kunt willekeurig afschrijven als de ondernemer:
                <br>
                <li class="list">voldoet aan de voorwaarden voor startersaftrek</li>
                <li class="list">investeerde in bepaalde milieubedrijfsmiddelen</li>
                <li class="list">investeerde in zeeschepen</li>

                Meer informatie over willekeurige afschrijving vind je hier:

                <div class="space20"></div>

                <snelstart-ui-button size="small" type="secondary" iconRight="arrow-up-right-from-square">
                    <a target="_blank"
                       href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/winst/inkomstenbelasting/inkomstenbelasting_voor_ondernemers/afschrijving/willekeurige_afschrijving/">
                        Fiscale informatie willekeurige afschrijving
                    </a>

                </snelstart-ui-button>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Schadeloosstelling buiten de winst om
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De ondernemer heeft bijvoorbeeld een schadevergoeding ontvangen bij onteigening van een pand of van
                grond. Deze heeft de ondernemer niet opgenomen in de winst-en-verliesrekening, omdat de ondernemer van
                mening bent dat hij hierover geen inkomstenbelasting hoeft te betalen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Start onderneming
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Meer informatie voor startende ondernemers</b><br/>
                Op deze website van de belastingdienst vind je veel informatie voor en over startende ondernemers:

                <div class="space20"></div>

                <snelstart-ui-button size="small" type="secondary" iconRight="arrow-up-right-from-square">
                    <a target="_blank"
                       href="https://www.belastingdienst.nl/wps/wcm/connect/nl/startende-ondernemer/startende-ondernemer">
                        Fiscale informatie startende ondernemers
                    </a>

                </snelstart-ui-button>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Staking of doorschuiving onderneming
            </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Heeft de ondernemer de onderneming geheel of gedeeltelijk beëindigd of overgedragen? Dan moet de
                ondernemer in principe belasting betalen over de stakingswinst. In bepaalde gevallen kan de
                belastingclaim over de stakingswinst worden doorgeschoven naar degene die de onderneming heeft
                overgenomen. Ook dan heeft de ondernemer misschien recht op stakingsaftrek. De stakingsaftrek is
                € {{ this.stakingsaftrek | number:'1.0-0' }} maar niet hoger dan het deel van de oudedagsreserve dat
                vrijvalt door het doorschuiven van de
                onderneming.

                <div class="space20"></div>

                <b>Wanneer kan een onderneming overgaan op iemand anders zonder inkomstenbelasting over de
                    overdrachtswinst (geruisloos doorschuiven)?</b><br/>
                In de volgende situaties kan een (gedeelte van een) een onderneming (onder voorwaarden) overgaan op
                iemand anders zonder eindafrekening:
                <li class="list">De ondernemer overlijdt en 1 of meerdere erfgenamen zetten de onderneming voort.</li>

                <li class="list">De ondernemer is gehuwd, de onderneming is gedeeld eigendom en het huwelijk van de
                    ondernemer wordt
                    ontbonden, waarbij de ondernemer 100% eigenaar wordt van de onderneming.
                </li>

                <li class="list">De ondernemer draagt zijn onderneming over aan een andere ondernemer uit het
                    samenwerkingsverband met wie de ondernemer al minimaal 36 maanden heeft samengewerkt.
                </li>

                <li class="list">De onderneming krijgt een doorstart.</li>

                <li class="list">De ondernemer brengt de hele onderneming onder in een eigen bv.</li>

                <li class="list">De ondernemer draagt de onderneming over aan een werknemer die al minimaal 36 maanden
                    bij de
                    ondernemer in loondienst is geweest.
                </li>

                <div class="space20"></div>

                <b>Stakingsbalans</b><br/>
                Is de onderneming gestaakt? Dan kun je aan het einde van het boekjaar opnemen in de balans. Dit doe je
                door de activa en passiva inclusief de stille reserves (de economische waarde) te vermelden. Het einde
                van het boekjaar is de datum waarop de ondernemer de onderneming heeft gestaakt. Deze datum kan
                samenvallen met het einde van het kalenderjaar. Bij het geruisloos doorschuiven van de onderneming
                worden op de fiscale eindbalans de activa en passiva niet vermeld naar de economische waarde. Dan
                schuiven de boekwaardes door naar de voortzettende ondernemer.

                <div class="space20"></div>

                <b>Desinvesteringsbijtelling</b><br/>
                Als de ondernemer (een deel van) de onderneming staakt, is er desinvesteringsbijtelling verschuldigd
                over de bedrijfsmiddelen waarvoor de ondernemer in het verleden investeringsaftrek heeft gekregen en
                waarvan de termijn waarbinnen desinvesteringsbijtelling is verschuldigd, nog niet is verstreken.

            </div>
        </div>
    </div>

</div>

